'use client';

import { c as _c } from "react/compiler-runtime";
import './panel-waivers.scss';
import { useTranslation } from 'react-i18next';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { Checkbox } from '@sola/ark-core/molecules/checkbox/checkbox.tsx';
import { Select } from '@sola/ark-core/molecules/select/select.tsx';
import { getContactDisplayName, isGuestContact, isMinor } from '../../../utils/volunteer-utils.ts';
import type { useVolunteerRegistrationSheet } from '../volunteer-registration-sheet.logic.ts';
import VolunteerWaiverEnglish from './panel-waiver-volunteer-agreement.tsx';
type Logic = ReturnType<typeof useVolunteerRegistrationSheet>;
export const PanelWaivers: React.FC<{
  logic: Logic;
}> = t0 => {
  const $ = _c(40);
  const {
    logic
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["volunteers"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== logic.selectedContacts) {
    t2 = logic.selectedContacts.filter(_temp).map(_temp2);
    $[1] = logic.selectedContacts;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const signerOptions = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("volunteers:registration.signWaiversTitle");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <h3 className="heading-xs md:heading-sm mb-snug-lg">{t3}</h3>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("volunteers:registration.signWaiversDescription");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <p className="body-sm body-neutral-mild pb-comfy-sm">{t5}</p>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("volunteers:registration.waiverSignerLabel");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== logic) {
    t8 = e => logic.setWaiverSignerId(e.target.value);
    $[13] = logic;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== logic.waiverSignerId || $[16] !== signerOptions || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className="PanelWaivers__select"><Select label={t7} name="waiverSigner" items={signerOptions} defaultValue={logic.waiverSignerId} onChange={t8} /></div>;
    $[15] = logic.waiverSignerId;
    $[16] = signerOptions;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== logic.registrants.length || $[21] !== t) {
    t10 = logic.registrants.length > 1 && <Alert variant="brand" message={t("volunteers:registration.waiverMultipleAlert")} />;
    $[20] = logic.registrants.length;
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="PanelWaivers__agreement overflow-y-auto bg-neutral-50 p-comfy-sm label-mild body-sm body-amplified"><VolunteerWaiverEnglish /></div>;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("volunteers:registration.waiverAgreementCheckbox");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== logic) {
    t13 = () => logic.setWaiverAgreed(!logic.waiverAgreed);
    $[26] = logic;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== logic.waiverAgreed || $[29] !== t12 || $[30] !== t13) {
    t14 = <div className="PanelWaivers__checkboxes flex flex-col gap-snug-lg md:gap-comfy-lg"><Checkbox label={t12} name="waiverAgreement" checked={logic.waiverAgreed} onChange={t13} /></div>;
    $[28] = logic.waiverAgreed;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t10 || $[33] !== t14 || $[34] !== t9) {
    t15 = <div className="flex flex-col gap-comfy-lg max-w-sm w-full mx-auto pt-comfy-sm">{t9}{t10}{t11}{t14}</div>;
    $[32] = t10;
    $[33] = t14;
    $[34] = t9;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15 || $[37] !== t4 || $[38] !== t6) {
    t16 = <div className="flex flex-col max-w-md mx-auto">{t4}{t6}{t15}</div>;
    $[36] = t15;
    $[37] = t4;
    $[38] = t6;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};
function _temp(contact) {
  return !isGuestContact(contact) || !isMinor(contact.ageRange);
}
function _temp2(contact_0) {
  return {
    value: contact_0.id,
    text: getContactDisplayName(contact_0, {
      variant: "full"
    })
  };
}